import { useEffect, useState } from "react";
import { useUser } from "../../../../context/UserContext";
import CopyIcon from "../../../../icon/CopyIcon";
import DownloadIcon from "../../../../icon/DownloadIcon";
import LogoutIcon from "../../../../icon/LogoutIcon";
import Card from "../../../Card/Card";
import classes from "./AccountDetails.module.css";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { formatAmount } from "../../../../utilities/functions";
import { env } from "../../../../constants/env";
import axios from "axios";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import useWindowDimensions from "../../../../hooks/getWindowDimensions";
import ListTooltip from "../../../../ui/ListTooltip/ListTooltip";
import { LuShare2, LuUpload } from "react-icons/lu";

export const InfoContainer = ({
  name,
  text,
  icon,
  className,
  textIconStyle,
}) => {
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${classes.inputContainer} ${className}`}
    >
      <div className={classes.nameContainer}>{name}</div>
      <div
        className={`d-flex align-items-center  gap-2 ${classes.textContainer} ${textIconStyle}`}
      >
        {text}
        {icon}
      </div>
    </div>
  );
};

const AccountDetails = ({
  setPayout,
  funded,
  purchasedAccount,
  amount,
  setShowOverlay,
  blurred,
  onShareCertificate,
  requestPayout,
  payoutEnabled,
  payoutAvailableDate,
  setShowPayoutFlow,
}) => {
  const now = new Date();
  const currentMonthName = now.toLocaleString("default", { month: "long" }); // e.g. "October"
  const currentYear = now.getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(currentMonthName);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const { user } = useUser();
  const [copyStatus, setCopyStatus] = useState("");
  const [showInvestorPass, setShowInvestorPass] = useState(false);
  const [showMasterPass, setShowMasterPass] = useState(false);
  const [fundedAccountsAvailable, setFundedAccountsAvailable] = useState(null);
  const [leaderboard, setLeaderboard] = useState(null);

  const { height, width } = useWindowDimensions();

  useEffect(() => {
    fetchFundedAccountsAvailable();
  }, [selectedMonth, selectedYear]);


  useEffect(() => {
      const fetchLeaderboard = async () => {
        try {
          const token = localStorage.getItem("userToken");
  
          const res = await axios.get(`${env.apiUrl}/api/leaderboard/me`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
  
          setLeaderboard(res.data);
        } catch (err) {
          console.error("Failed to load leaderboard", err);
        } finally {
      
        }
      };
  
      fetchLeaderboard();
    }, []);

  const fetchFundedAccountsAvailable = async () => {
    try {
      const monthIndex =
        new Date(`${selectedMonth} 1, ${selectedYear}`).getMonth() + 1; // convert month name to number
      const res = await fetch(
        `${env.apiUrl}/api/funded-accounts/available?month=${monthIndex}&year=${selectedYear}`
      );
      if (!res.ok) throw new Error("Failed to fetch funded accounts available");
      const data = await res.json();
      setFundedAccountsAvailable(data.available || 0); // assumes API returns { available: number }
    } catch (err) {
      console.error(err);
      setFundedAccountsAvailable(0);
    }
  };

  const challengeDetailsList = [
    {
      name: "Initial balance",
      desc: `${formatAmount(amount)}`,
    },
    {
      name: "Plan type",
      desc: "Challenger",
    },
    {
      name: "Group trading",
      desc: "No",
    },
  ];

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopyStatus("Text copied!");
      toast.success("Text copied!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopyStatus("Failed to copy text.");
    }
  };
  return (
    <div className="row position-relative">
      {blurred && (
        <div className={`${classes.blurOverlay} `}>
          <div
            className={`${classes.overlayCard} d-flex justify-content-center align-items-center`}
          >
            <h4>
              MT5 logins will be synced <br />
              <span className={classes.dateText}>17th September, 2pm PST</span>
            </h4>
          </div>
        </div>
      )}
      <div className={`col-md-9`}>
        {/* Blur and Overlay Card */}

        <Card
          className={`${classes.cardWrapper} d-flex justify-content-center align-items-center`}
        >
          <div className="row px-2 m-0 w-100">
            <div className="col-md-6 p-0 pe-md-1">
              <InfoContainer
                name="Login"
                text={user?.account?.accountId}
                icon={
                  <CopyIcon
                    onClick={() => handleCopy(user?.account?.accountId)}
                  />
                }
              />
            </div>
            <div className="col-md-6 mt-md-0 mt-2 p-0 ps-md-1">
              <InfoContainer
                name="Investor Pass."
                text={
                  showInvestorPass ? user?.account?.investorPassword : "•••••••"
                }
                icon={
                  <>
                    <div>
                      {showInvestorPass ? (
                        <IoEyeOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowInvestorPass(false)}
                        />
                      ) : (
                        <IoEyeOffOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowInvestorPass(true)}
                        />
                      )}
                    </div>
                    <CopyIcon
                      onClick={() =>
                        handleCopy(user?.account?.investorPassword)
                      }
                    />
                  </>
                }
              />
            </div>
            <div className="col-md-6 p-0 mt-2 pe-md-1">
              <InfoContainer
                name="Master Pass."
                text={
                  showMasterPass ? user?.account?.masterPassword : "•••••••"
                }
                icon={
                  <>
                    <div>
                      {showMasterPass ? (
                        <IoEyeOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowMasterPass(false)}
                        />
                      ) : (
                        <IoEyeOffOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowMasterPass(true)}
                        />
                      )}
                    </div>
                    <CopyIcon
                      onClick={() => handleCopy(user?.account?.masterPassword)}
                    />
                  </>
                }
              />
            </div>
            <div className="col-md-6 p-0 mt-2 ps-md-1">
              <InfoContainer
                name="MT5 Server"
                text={user?.account?.mt5Server}
                icon={<DownloadIcon onClick={setShowOverlay} />}
              />
            </div>
          </div>
          {/* {!funded && !blurred && width > 768 && (
            <div
              className={`${classes.challengeDetails} d-flex flex-column gap-3`}
            >
              {challengeDetailsList.map((item, i) => (
                <div className="d-flex align-items-center gap-2" key={i}>
                  <IoIosCheckmarkCircleOutline color="#30970B" size={19} />
                  <div
                    className={classes.challengeDetailText}
                  >{`${item.name}: ${item.desc}`}</div>
                </div>
              ))}
            </div>
          )} */}
        </Card>
        {/* {!funded && !blurred && width <= 768 && (
          <Card className={`${classes.cardWrapper} mt-3`}>
            <div className={`d-flex flex-column gap-3`}>
              {challengeDetailsList.map((item, i) => (
                <div className="d-flex align-items-center gap-2" key={i}>
                  <IoIosCheckmarkCircleOutline color="#30970B" size={19} />
                  <div
                    className={classes.challengeDetailText}
                  >{`${item.name}: ${item.desc}`}</div>
                </div>
              ))}
            </div>
          </Card>
        )} */}
      </div>
      <div className="col-md-3 mt-3 mt-md-0">
        <Card
          className={`${classes.cardWrapper} d-flex flex-column justify-content-center align-items-center gap-2`}
        >
          {payoutEnabled && user.account.userStage === 3 ? (
            <>
              <LogoutIcon
                color={payoutEnabled ? "var(--primary-color)" : "#737373"}
                upRight
                onClick={payoutEnabled ? () => setShowPayoutFlow(true) : undefined}
                style={{ cursor: payoutEnabled ? "pointer" : "not-allowed", opacity: payoutEnabled ? 1 : 0.4 }}
              />
              <h5 className={classes.requestPayoutTitle} style={{ color: payoutEnabled ? undefined : "#737373" }}>
                Request Payout
              </h5>
              {!payoutEnabled && payoutAvailableDate ? (
                <span className={classes.termsLink} style={{ fontSize: "11px", textAlign: "center" }}>
                  Available {payoutAvailableDate.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                </span>
              ) : (
                <span className={classes.termsLink}>Terms</span>
              )}
            </>
          ) : funded && !purchasedAccount ? (
            <>
              <h5>Challenge completed</h5>
              <span onClick={() => setPayout(true)}>Claim funded account</span>
            </>
          ) : (
            <>
              <h4 className={classes.rankNumber}>#{leaderboard?.rank || "-"}</h4>
              <p className={classes.labelText}>Rank</p>
              <button
                className={classes.shareCertificateButton}
                onClick={onShareCertificate}
              >
                <LuShare2 color="var(--primary-color)" /> Share
              </button>
            </>
          )}
        </Card>
      </div>

      {/* <div className="col-md-3 mt-3 mt-md-0">
        <Card
          className={`${classes.cardWrapper} d-flex flex-column justify-content-center align-items-center gap-2`}
        >
          {funded ? (
            <>
              <h5>Challenge completed</h5>
              <span onClick={() => setPayout(true)}>Claim funded account</span>
            </>
          ) : (
            <>
              <h2>{fundedAccountsAvailable ?? "-"}</h2>
              <div className={`d-flex  align-items-center gap-2`}>
                <h5>Funded Accounts Available</h5>{" "}
                <ListTooltip
                  tooltipCard={classes.tooltipCard}
                  text=""
                  info="This indicates how many funded slots are available in the current cohort. Once filled, the challenge ends and traders in profit receive a free entry into next month’s cohort."
                />
              </div>
            </>
          )}
        </Card>
      </div> */}
    </div>
  );
};

export default AccountDetails;
